/**
 * Formula di saluto della home, declinata sui pronomi scelti in configurazione.
 *
 * È l'unico testo declinato di tutto il gestionale: non ci sono firme, e
 * l'unica email generata è neutra e parla al cliente. Sta comunque in una
 * funzione sua, perché il giorno che i testi declinati saranno tre si
 * cambierà un file solo.
 */
const GREETINGS = Object.freeze({
  lui: "Bentornato,",
  lei: "Bentornata,",
  loro: "Bentornatə,",
});

/** Formula usata da chi non ha detto i propri pronomi. È quella di sempre. */
export const NEUTRAL_GREETING = "Bentornato/a,";

/**
 * @param {string|null|undefined} pronouns
 * @returns {string}
 */
export function greetingFor(pronouns) {
  return GREETINGS[pronouns] || NEUTRAL_GREETING;
}

export default greetingFor;
